import React, { memo } from "react";
import styled from "styled-components";
import icon_info_warning_dialog from "assets/icon_info_warning_dialog.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ModalWarning = memo(({ className, onCancel, isOpen }) => {
  const { t } = useTranslation("translation");
  return (
    <div className={className}>
      <div className=" text-center relative justify-center items-center">
        <div className="text-center font-700 fs-16 ml-4 mr-4">
          {t("titleForgotPass")}
        </div>
        <div className="text-center ml-4 mr-4 text-content mt-1">
          {t("contentForgotPass")}
        </div>
        <div className=" w-full flex justify-center items-center">
          <div
            onClick={onCancel}
            className=" text-center flex justify-center items-center mt-3 btn"
          >
            <div className="text_yes">{t("ok")}</div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default styled(ModalWarning)`
  .text-content {
    line-height: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #808080;
    font-family: "Manrope", sans-serif;
  }
  .btn {
    width: 160px;
    height: 50px;
    border-radius: 6px;
    background: #1a1a1a;
  }
  .text_yes {
    line-height: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    font-family: "Manrope", sans-serif;
  }
`;
